import React from 'react';

import { Button } from '@material-ui/core';

function AxlMuiButton(props) {
  const {label, onClick, size = 'small', style, ...otherProps} = props;
  return (
    <Button 
      onClick={onClick} 
      size={size} 
      style={{color: '#fff', fontSize: 12, fontFamily: 'AvenirNext', ...style}}
      {...otherProps}
    >
      {label}
    </Button>
  )
}

export default AxlMuiButton